/** Claim Payment*/
export const CREATE_REMITTANCE = 'CREATE_REMITTANCE';
export const EDIT_REMITTANCE = 'EDIT_REMITTANCE';
export const GET_REMITTANCE = 'GET_REMITTANCE';
export const GET_REMITTANCE_SUCCESS = 'GET_REMITTANCE_SUCCESS';
export const VERIFY_REMITTANCES = 'VERIFY_REMITTANCES';
export const MARK_REVIEWED_REMITTANCE = 'MARK_REVIEWED_REMITTANCE';
export const SYNC_TL_CLEARINGHOUSE_ERAS = 'SYNC_TL_CLEARINGHOUSE_ERAS';
export const GET_REMITTANCE_BY_ID = 'GET_REMITTANCE_BY_ID';
export const GET_REMITTANCE_BY_ID_SUCCESS = 'GET_REMITTANCE_BY_ID_SUCCESS';

export const GET_REMITTANCE_BY_ID_CLAIMS = 'GET_REMITTANCE_BY_ID_CLAIMS';
export const GET_REMITTANCE_BY_ID_CLAIMS_SUCCESS = 'GET_REMITTANCE_BY_ID_CLAIMS_SUCCESS';

export const VOID_REMITTANCE = 'VOID_REMITTANCE';
export const MASS_VOID_REMITTANCE = 'MASS_VOID_REMITTANCE';
export const DELETE_REMITTANCE = 'DELETE_REMITTANCE';
export const GET_REMITTANCE_TOTAL = 'GET_REMITTANCE_TOTAL';
export const GET_REMITTANCE_TOTAL_SUCCESS = 'GET_REMITTANCE_TOTAL_SUCCESS';

export const GET_CLAIM_PAYMENT_FILTERED = 'GET_CLAIM_PAYMENT_FILTERED';
export const GET_CLAIM_PAYMENT_FILTERED_SUCCESS = 'GET_CLAIM_PAYMENT_FILTERED_SUCCESS';
export const GET_CLAIM_PAYMENTS = 'GET_CLAIM_PAYMENTS';
export const GET_CLAIM_PAYMENTS_SUCCESS = 'GET_CLAIM_PAYMENTS_SUCCESS';

export const EDIT_CLAIM_PAYMENT_INFO = 'EDIT_CLAIM_PAYMENT_INFO';

export const APPEAL_CLAIM_PAYMENT = 'APPEAL_CLAIM_PAYMENT';

export const PAY_IN_FULL_CLAIM = 'PAY_IN_FULL_CLAIM';

export const PAY_IN_FULL_CLAIM_BILLING = 'PAY_IN_FULL_CLAIM_BILLING';
export const REMOVE_CLAIM_FROM_REMITTANCE = 'REMOVE_CLAIM_FROM_REMITTANCE';

/** End */
